import React, { useEffect, useState } from 'react';
import { FacturasAdapter } from '../../../../../../infraestructure/persistence/rest/FacturasAdapter';
import { PERFIL_ADMIN } from '../../../../../../shared/constanst/constants';
import { useNotifications } from '../../../../../../shared/hooks/Notifications';
import { ServerErrorMessage } from '../../../../../../shared/utils/error';
import { SociedadDetalleScreen } from './sociedadDetalleScreen';
import { blobToFile } from '../../../../../../shared/utils/conversions';
import { GenerateHistoricoPDF } from '../Pdf/historico';
import { CreatePDF } from '../Pdf';

interface Props{
    dataFilter:any;
	user:any;
	rolPermiso:any;
	showFacturacion:boolean;
	translate(word:string):any
}

export const SociedadDetalleComponent = (props:Props) =>{
    
    const {dataFilter,user,rolPermiso,showFacturacion,translate} = props;
	const {idSociedad} = dataFilter;

	const api:any = new FacturasAdapter();
	const {resultError, exceptionError, launchNotification}:any = useNotifications();

	const [dataHistorico,setDataHistorico] = useState([])
	let [isLoading, setIsLoading] = useState<any>({stateLoad:false,type:''});
	let result: any;

	useEffect(()=>{
		setDataHistorico([])
		setTimeout(() => {
			dataFilter && GetHistoricoFacturacionExpatriados({TipoAgrupacion:1,AgrupacionDestinoFactura:dataFilter.idSociedad});
		  }, 900);
	},[idSociedad])

    const VisualizarFacturacionExpatriados = async (dataDownload:any, rolPermiso:string) => {
		const esAdm:boolean = (user.perfil === PERFIL_ADMIN || user.administraExpatriados);
		const request = {...dataDownload,...{rolPermiso:rolPermiso,esFacturacion:false}};

		const _loader = {stateLoad:true,type:'v'}
		setIsLoading({..._loader})
		try {
			result = await api.FacturacionExpatriadosPorSociedad(request);
			if(result.data && result.data!=="")
			{
				if(result.data.length===0)
				launchNotification({type:'warning',title:translate('generacion-pdf'),message:`${translate('msg-notificacion-no-datos-documento')}.`})
				else
				CreatePDF(result.data,dataDownload.irpf,esAdm,false,translate);
			}else{resultError()}
			setIsLoading(false)
		} catch (error) {
			let exception = ServerErrorMessage(error);
			exceptionError(exception)
			const _loader = {stateLoad:false,type:''}
			setIsLoading({..._loader})
		}
	};

	const GetHistoricoFacturacionExpatriados = async (dataRequest:any) => {
		try {
			result = await api.ListarHistoricoFacturacionExpatriados(dataRequest);
			if(result.data && result.data!=="")
			{
				setDataHistorico(result.data)
			}else{resultError()}
			//setIsLoading(false)
		} catch (error) {
			let exception = ServerErrorMessage(error);
			exceptionError(exception)
			//setIsLoading(false)
		}
	};

	// const GetHistoricoFile = async (dataDownload:any)=>{
		
	// 	try {
	// 		result = await api.GenerarHistoricoBS64Copia();
	// 		if(result.data && result.data!=="")
	// 		{
	// 			if(result.data === true)
	// 				launchNotification({type:'success',title:translate('generacion-pdf'),message:`Se ha generado el archivo histórico.`})
	// 			else{
	// 				launchNotification({type:'error',title:translate('generacion-pdf'),message:`Se ha producido un error al generar el archivo histórico.`})
	// 			}
				
	// 		}else{resultError()}
	// 	} catch (error) {
	// 		let exception = ServerErrorMessage(error);
	// 		exceptionError(exception)

	// 	}
	// }

	// const GetHistoricoFile = async (data:Blob, idFactura:string)=>{
	// 	const file = blobToFile(data,idFactura)
	// 	const dataRequest = {fichero:file,idFactura:idFactura};
	// 	try {
	// 		result = await api.GenerarHistoricoBS64(dataRequest);
	// 		if(result.data && result.data!=="")
	// 		{
	// 			if(result.data === true)
	// 				launchNotification({type:'success',title:translate('generacion-pdf'),message:`Se ha generado el archivo histórico.`})
	// 			else{
	// 				launchNotification({type:'error',title:translate('generacion-pdf'),message:`Se ha producido un error al generar el archivo histórico.`})
	// 			}
				
	// 		}else{resultError()}
	// 	} catch (error) {
	// 		let exception = ServerErrorMessage(error);
	// 		exceptionError(exception)

	// 	}
	// }


	// const GetHistoricoFacturaExpatriados = async (idFactura:string, rolPermiso:string) => {
	// 	const request = {idFactura:idFactura,rolPermiso:rolPermiso,esFacturacion:true}
	// 	try {
	// 		result = await api.GetHistoricoFacturacionExpatriados(request);
	// 		if(result.data && result.data!=="")
	// 		{
	// 			if(result.data.length===0)
	// 			launchNotification({type:'warning',title:translate('generacion-pdf'),message:`${translate('msg-notificacion-no-datos-documento')}.`})
	// 			else{
	// 				await GenerateHistoricoPDF(result.data,translate,GetHistoricoFile);
	// 			}
				
	// 		}else{resultError()}
	// 	} catch (error) {
	// 		let exception = ServerErrorMessage(error);
	// 		exceptionError(exception)
	// 		//setIsLoading(false)
	// 	}
	// };

	// const GenerarFacturacionExpatriados_old = async (data:any, rolPermiso:string) => {
	// 	setIsLoading(true)
	// 	try {
	// 		result = await api.GenerarFacturacionExpatriados(data);
	// 		if(result.data!==null && result.data!=="")
	// 		{
	// 			const _dataHistorico = result.data;
	// 			// if(result.data === true)
	// 			// {
	// 				launchNotification({type:'success',title:translate('generar-factura'),message:`${translate('msg-notificacion-generar-factura')}.`})
	// 				await GetHistoricoFacturacionExpatriados({TipoAgrupacion:1,AgrupacionDestinoFactura:data.id});
	// 				await GenerateHistoricoPDF(_dataHistorico,translate,GetHistoricoFile);
	// 				//await GetHistoricoFacturaExpatriados(data.idFactura, rolPermiso)
	// 			// }else{
	// 			// 	launchNotification({type:'warning',title:translate('generar-factura'),message:`${translate('msg-notificacion-no-datos-generar-factura')}.`})
	// 			// }
	// 		}else{resultError();launchNotification({type:'warning',title:translate('generar-factura'),message:`${translate('msg-notificacion-no-datos-generar-factura')}.`})}
	// 		setIsLoading(false)
	// 	} catch (error) {
	// 		let exception = ServerErrorMessage(error);
	// 		exceptionError(exception)
	// 		setIsLoading(false)
	// 	}
	// };

	const GenerarFacturacionExpatriados = async (data:any, rolPermiso:string) => {
		const _loader = {stateLoad:true,type:'f'}
		setIsLoading({..._loader})
		try {
			result = await api.FacturacionExpatriadosPorSociedad(data);
			if(result.data!==null && result.data!=="")
			{
				const _dataHistorico = result.data;
				_dataHistorico[0].informe.total.idFactura=data.idFactura;
				let pdfHistorico:any = undefined;
				pdfHistorico = await GenerateHistoricoPDF(_dataHistorico,translate);

				if(pdfHistorico!==undefined){

					const file = new File([pdfHistorico], data.idFactura+'.pdf',{type: "application/pdf"});
					result = await api.GenerarFacturacionExpatriados(data,file);

					if(result.data === true || (result.data!==null && result.data!==""))
					{
						launchNotification({type:'success',title:translate('generar-factura'),message:`${translate('msg-notificacion-generar-factura')}.`})
						await GetHistoricoFacturacionExpatriados({TipoAgrupacion:1,AgrupacionDestinoFactura:data.id});
					}
				}
				
			}else{resultError();launchNotification({type:'warning',title:translate('generar-factura'),message:`${translate('msg-notificacion-no-datos-generar-factura')}.`})}
			setIsLoading(false)
		} catch (error) {
			let exception = ServerErrorMessage(error);
			exceptionError(exception)
			const _loader = {stateLoad:false,type:''}
			setIsLoading({..._loader})
		}
	};

	//Funcion para pruebas
	const GenerarFacturaAs400 = async (idFactura:string, tipoSociedad:string) => {
		setIsLoading(true)
		try {
			result = await api.GenerarFacturaExpatriadosAs400(idFactura, tipoSociedad);
			if(result.data!==null && result.data!=="")
			{
				launchNotification({type:'success',title:'Fichero AS400',message:'Generado fichero AS400'})
			}else{resultError();launchNotification({type:'warning',title:translate('generar-factura'),message:`${translate('msg-notificacion-no-datos-generar-factura')}.`})}
			setIsLoading(false)
		} catch (error) {
			let exception = ServerErrorMessage(error);
			exceptionError(exception)
			setIsLoading(false)
		}
	};

	let propsToChild = {
		dataFilter:dataFilter,
		onVisualizarFacturacion:VisualizarFacturacionExpatriados,
		//onVisualizarFacturacion:GetHistoricoFile,
		onGenerarFactura:GenerarFacturacionExpatriados,
		data:dataHistorico,
		isLoading:isLoading,
		user:user,
		translate:translate,
		rolPermiso:rolPermiso,
		showFacturacion:showFacturacion,
		onFacturaAs400:GenerarFacturaAs400
	}

    return <SociedadDetalleScreen {...propsToChild}/>
}